import React from 'react'
import AppFeature from './components/Features/AppFeature'
import './Fun.css'

function Fun() {
    return (
        <div className="legal">
            <h1>Games and Entertainment</h1>
            <p>
                Lie back and enjoy these iOS Games or other Software with Entertainment Value created as part of internal Hackathons or just for Fun in General.
           </p>

            <div class="app_grid">
                <AppFeature
                    title="Cirlces"
                    text1='Eat   the Dots'
                    text2='"Simply Addictive"'
                    previewSrc="assets/img/icons/sirjoeentertainment/circles_preview.png"
                    iconSrc="assets/img/icons/sirjoeentertainment/circles_icon.png"
                    appStore="https://apps.apple.com/us/app/circles-worlds-easiest-game/id1328385971"
                    playStore="" />

                <AppFeature
                    title="Wink Terror"
                    text1='Torture'
                    text2='all your Friends'
                    previewSrc="assets/img/icons/sirjoeentertainment/winkterror_preview.png"
                    iconSrc="assets/img/icons/sirjoeentertainment/winkterror_icon.png"
                    appStore="https://apps.apple.com/us/app/wink-terror/id1440412163"
                    playStore="" />


                <AppFeature
                    title="The Dollar Game"
                    text1='Math Puzzle'
                    text2='for the smart'
                    previewSrc="assets/img/icons/sirjoeentertainment/dollar_game_preview2.png"
                    iconSrc="assets/img/icons/sirjoeentertainment/dollar_game_icon.png"
                    appStore="https://apps.apple.com/us/app/the-dollar-game-puzzle/id1435202300"
                    playStore="" />

                <AppFeature
                    title="Towerblox"
                    text1='Build High'
                    text2='the sky is the limit'
                    previewSrc="assets/img/icons/sirjoeentertainment/towerblox_preview.png"
                    iconSrc="assets/img/icons/sirjoeentertainment/towerblox_icon.png"
                    appStore="https://apps.apple.com/us/app/tower-blox-stack-the-blocks/id1484795479"
                    playStore="" /> 

                <AppFeature
                    title="Shape Rush"
                    text1='Great Puzzler'
                    text2='match colors, be the fastest'
                    previewSrc="assets/img/icons/sirjoeentertainment/shape_rush_preview.png"
                    iconSrc="assets/img/icons/sirjoeentertainment/shape_rush_icon.png"
                    appStore="https://apps.apple.com/us/app/shape-rush-fast-puzzle/id1472140860"
                    playStore="" /> 

                <AppFeature
                    title="Seal Workout"
                    text1='Beat Buds'
                    text2='train like a seal'
                    previewSrc="assets/img/icons/sirjoeentertainment/seal_workout_preview.png"
                    iconSrc="assets/img/icons/sirjoeentertainment/seal_workout_icon.png"
                    appStore="https://apps.apple.com/us/app/seal-body-weight-trainer/id1424237517"
                    playStore="" /> 
            </div>     
        </div>
    )
}

export default Fun
